<div>
  <form [formGroup]="bsaProfileForm">
    <fieldset>
      <legend class="section-sub-label">Account Details</legend>
      <div fxLayout="row" fxLayout.xs="column">
        <div [fxFlex]="70">
          <div>Will you be conducting ACH transactions?</div>
        </div>

        <div [fxFlex]="30">
          <div>
            <mat-radio-group class="profile-radio-group" formControlName="achTransactions" id="achTransactions">
              <mat-radio-button [value]="true" id="achTransactionsYes">Yes</mat-radio-button>
              <mat-radio-button [value]="false" id="achTransactionsNo">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>

      <div fxLayout="row" fxLayout.xs="column">
        <div [fxFlex]="70">
          <div>Will you be conducting wire transactions domestically?</div>
        </div>

        <div [fxFlex]="30">
          <div>
            <mat-radio-group class="profile-radio-group" formControlName="wireDomestic" id="wireDomestic">
              <mat-radio-button [value]="true" id="wireDomesticYes">Yes</mat-radio-button>
              <mat-radio-button [value]="false" id="wireDomesticNo">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>

      <div fxLayout="row" fxLayout.xs="column">
        <div [fxFlex]="70">
          <div>Will you be conducting wire transactions internationally?</div>
        </div>

        <div [fxFlex]="30">
          <div>
            <mat-radio-group class="profile-radio-group" formControlName="wireInternational" id="wireInternational">
              <mat-radio-button [value]="true" id="wireInternationalYes">Yes</mat-radio-button>
              <mat-radio-button [value]="false" id="wireInternationalNo">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>

      <div fxLayout="row" fxLayout.xs="column">
        <div [fxFlex]='100'>
          <div [hidden]="!getFormControlValue('wireInternational')" class="bottom-separation">
            <mat-form-field appearance="outline">
              <mat-label>International Countries</mat-label>
              <mat-chip-list #chipList aria-label="Country Selection"
                             id="internationalCountry"
              >
                <mat-chip
                  (removed)="remove(country.countryId)"
                  *ngFor="let country of getSelectedCountryList()"
                  [removable]="removable"
                >
                  {{country.countryName}}
                  <mat-icon *ngIf="removable" matChipRemove>cancel</mat-icon>
                </mat-chip>
                <input #countryInput
                       (matChipInputTokenEnd)="tokenAdded($event)"
                       [matAutocomplete]="auto"
                       [matChipInputFor]="chipList"
                       [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                       formControlName="countryInput"
                       id="internationalCountryInput"
                       placeholder="Add Country..."
                >
              </mat-chip-list>
              <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)"
                                id="internationalCountryAutocomplete">
                <mat-option *ngFor="let country of filteredCountries | async" [value]="country">
                  {{country.countryName}}
                </mat-option>
              </mat-autocomplete>
              <mat-hint>
                You may select up to 5 countries.
              </mat-hint>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div fxLayout="row" fxLayout.xs="column">
        <div [fxFlex]="70">
          <div>Will you be conducting cash transactions?</div>
        </div>

        <div [fxFlex]="30">
          <div>
            <mat-radio-group class="profile-radio-group" formControlName="cashTransactions" id="cashTransactions">
              <mat-radio-button [value]="true" id="cashTransactionsYes">Yes</mat-radio-button>
              <mat-radio-button [value]="false" id="cashTransactionsNo">No</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>

      <div fxLayout="column" fxLayout.xs="column" class="section">
        <div fxLayout="row" fxLayout.xs="column">
          <div [fxFlex]="70">
            <div>Will you utilize a debit card?</div>
          </div>

          <div [fxFlex]="30">
            <div>
              <mat-radio-group class="profile-radio-group" formControlName="useDebitCard" id="useDebitCard">
                <mat-radio-button [value]="true" id="useDebitCardYes">Yes</mat-radio-button>
                <mat-radio-button [value]="false" id="useDebitCardNo">No</mat-radio-button>
              </mat-radio-group>
            </div>

          </div>
        </div>
       <div *ngIf="displayDebitOrder">
        <div [hidden]="!isDebitCardDetailsVisible" class="sub-section">
          <div fxLayout="row" fxLayout.xs="column" class="sub-option">
            <div [fxFlex]="70" fxLayoutAlign="start start">
              <div>Would you like to order a debit card?</div>
            </div>

            <div [fxFlex]="30">
              <mat-radio-group formControlName="orderDebitCard" id="orderDebitCard" class="profile-radio-group">
                <mat-radio-button id="orderDebitCardYes" [value]="true">Yes</mat-radio-button>
                <mat-radio-button id="orderDebitCardNo" [value]="false">No</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div fxLayout="row" fxLayout.xs="column" class="sub-option" [hidden]="!isDebitCardForVisible">
            <div [fxFlex]="70" fxLayoutAlign="start center">
              <div>Which applicant would like to order a debit card?</div>
            </div>

            <div [fxFlex]="30" fxLayoutAlign="end start">
              <mat-form-field appearance="outline" class="sub-option-list">
                <mat-select matInput required id="debitCardOrderFor" formControlName="debitCardOrderFor">
                  <mat-option *ngFor="let option of orderForOptions" [value]="option.value">
                    {{option.label}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
       </div>
      </div>
      <div fxLayout="column" fxLayout.xs="column" class="section">
        <div fxLayout="row" fxLayout.xs="column">
          <div [fxFlex]="70">
            <div>Will you utilize checks?</div>
          </div>

          <div [fxFlex]="30">
            <div>
              <mat-radio-group class="profile-radio-group" formControlName="useChecks" id="useChecks">
                <mat-radio-button [value]="true" id="useChecksYes">Yes</mat-radio-button>
                <mat-radio-button [value]="false" id="useChecksNo">No</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
       <div *ngIf="displayCheckOrder">
        <div [hidden]="!isChecksDetailsVisible" class="sub-section">
          <div fxLayout="row" fxLayout.xs="column" class="sub-option">
            <div [fxFlex]="70" fxLayoutAlign="start start">
              <div>Would you like to order checks?</div>
            </div>

            <div [fxFlex]="30">
              <mat-radio-group formControlName="orderChecks" id="orderChecks" class="profile-radio-group">
                <mat-radio-button id="orderChecksYes" [value]="true">Yes</mat-radio-button>
                <mat-radio-button id="orderChecksNo" [value]="false">No</mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
          <div fxLayout="row" fxLayout.xs="column" class="sub-option" [hidden]="!isChecksForVisible">
            <div [fxFlex]="70" fxLayoutAlign="start center">
              <div>Which applicant would like to order checks?</div>
            </div>

            <div [fxFlex]="30" fxLayoutAlign="end start">
              <mat-form-field appearance="outline" class="sub-option-list">
                <mat-select matInput required id="checksOrderFor" formControlName="checksOrderFor">
                  <mat-option *ngFor="let option of orderForOptions" [value]="option.value">
                    {{option.label}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
       </div>
      </div>
    </fieldset>
  </form>
</div>